import Vue from 'vue';
import Router from 'vue-router';
import Search from './views/Search.vue';
import About from './views/About.vue';

Vue.use(Router);

// I think this is the best option for routing, but we'll need to configure htaccess or nginx to be ready for these urls: https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/search/',
      name: 'Search',
      component: Search,
    },
    {
      path: '/search/node',
      redirect: '/search/',
    },
    {
      path: '/search/about',
      name: 'About',
      component: About,
    },
  ],
});
